module.exports = __webpack_public_path__ + "img/upload_plus.660ae8e4.svg";